import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert"
}
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "projectList" }
const _hoisted_4 = {
  key: 1,
  class: "cookies"
}
const _hoisted_5 = { class: "button" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_banner = _resolveComponent("banner")
  const _component_router_view = _resolveComponent("router-view")
  const _component_foot = _resolveComponent("foot")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_banner, {
      ref: "banner",
      onLoginClick: $options.loginShow
    }, null, 8, ["onLoginClick"]),
    _createVNode(_component_router_view, {
      onMsg: $options.getMsg,
      ref: "routerView"
    }, null, 8, ["onMsg"]),
    _createVNode(_component_foot),
    ($data.message)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass($data.isSuccess ? 'success alert-content' : ' alert-content')
          }, _toDisplayString($data.message), 3)
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      class: "chooseLogin",
      style: _normalizeStyle({top:$data.topScroll + 'px'})
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          class: "closeImg",
          src: "static/image/close.png",
          alt: "",
          onClick: _cache[0] || (_cache[0] = (...args) => ($options.closeLogin && $options.closeLogin(...args)))
        }),
        _cache[8] || (_cache[8] = _createElementVNode("div", {
          class: "title",
          "data-lang": "menu.chooseProduct"
        }, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "projectList_top",
            onClick: _cache[1] || (_cache[1] = (...args) => ($options.toLogin && $options.toLogin(...args)))
          }, _cache[6] || (_cache[6] = [
            _createElementVNode("img", {
              src: "static/image/iconSMS.png",
              alt: ""
            }, null, -1),
            _createTextVNode(" SMS ")
          ])),
          _createElementVNode("div", {
            class: "projectList_top",
            onClick: _cache[2] || (_cache[2] = (...args) => ($options.toLoginWhatsApp && $options.toLoginWhatsApp(...args)))
          }, _cache[7] || (_cache[7] = [
            _createElementVNode("img", {
              src: "static/image/Whatsapp1.svg",
              alt: ""
            }, null, -1),
            _createTextVNode(" WhatsApp ")
          ]))
        ])
      ])
    ], 4), [
      [_vShow, $data.loginFlag]
    ]),
    ($data.onShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[9] || (_cache[9] = _createElementVNode("div", null, " This website uses cookies to ensure you get the best experience on our website. ", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "button-left",
              onClick: _cache[3] || (_cache[3] = (...args) => ($options.onClose && $options.onClose(...args)))
            }, "Decline"),
            _createElementVNode("div", {
              class: "button-right",
              onClick: _cache[4] || (_cache[4] = (...args) => ($options.onClose && $options.onClose(...args)))
            }, "Allow All"),
            _createElementVNode("div", {
              class: "close",
              onClick: _cache[5] || (_cache[5] = (...args) => ($options.onClose && $options.onClose(...args)))
            }, "×")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}